const _temp0 = require("../NarrativeElement/icons/edit_item.svg");
const _temp1 = require("../NarrativeElement/icons/help.svg");
const _temp2 = require("../NarrativeElement/icons/open_chat.svg");
const _temp3 = require("../NarrativeElement/icons/regenerate_item.svg");
const _temp4 = require("../NarrativeElement/icons/trash.svg");
module.exports = {
  "edit_item": _temp0,
  "help": _temp1,
  "open_chat": _temp2,
  "regenerate_item": _temp3,
  "trash": _temp4
}